// extracted by mini-css-extract-plugin
export default {"loader":"ThreeDotsLoader_loader__z1mPT","dot":"ThreeDotsLoader_dot__tsA6E","threeDotsPulse":"ThreeDotsLoader_threeDotsPulse__nmARN"};